<template>
  <div class="container mx-auto px-4 py-8 max-w-3xl">
    <div class="flex justify-between items-start mb-8">
      <div>
        <h1 class="text-3xl font-bold text-gray-800">{{ menu.title }}</h1>
        <p v-if="menu.description" class="text-gray-500 mt-2">
          {{ menu.description }}
        </p>
      </div>
      <div class="flex gap-3">
        <Link
          :href="previewTastingMenuPath"
          class="bg-emerald-600 text-white px-4 py-2 rounded-lg hover:bg-emerald-700 transition-colors text-sm"
        >
          Förhandsgranska & Exportera PDF
        </Link>
        <Link
          v-if="currentUser?.admin"
          :href="editTastingMenuPath"
          class="bg-gray-200 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-300 transition-colors text-sm"
        >
          Redigera
        </Link>
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <div
        v-for="course in menu.courses"
        :key="course.id"
        class="bg-white rounded-lg shadow overflow-hidden"
      >
        <div class="flex">
          <div v-if="course.recipe.coverImage" class="w-24 h-24 flex-shrink-0">
            <img
              :src="course.recipe.coverImage.small"
              :alt="course.recipe.title"
              class="w-full h-full object-cover"
            />
          </div>
          <div class="p-4 flex-1">
            <div class="flex items-center gap-2 mb-1">
              <span
                class="text-xs font-bold text-emerald-600 bg-emerald-50 px-2 py-0.5 rounded"
              >
                {{ course.courseName }}
              </span>
            </div>
            <h3 class="text-lg font-semibold text-gray-800">
              {{ course.recipe.title }}
            </h3>
            <p class="text-sm text-gray-500 mt-1">
              {{ course.recipe.ingress }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-8">
      <Link :href="tastingMenusPath" class="text-gray-500 hover:text-gray-700">
        ← Tillbaka till menyer
      </Link>
    </div>
  </div>
</template>

<script setup>
import { Link } from "@inertiajs/vue3";

defineProps({
  menu: Object,
  currentUser: Object,
  csrfToken: String,
  tastingMenusPath: String,
  editTastingMenuPath: String,
  previewTastingMenuPath: String,
});
</script>
